/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ShareChatThreadContentResponse = zod.object({
  sharedCount: zod.int().describe('Members the content was shared with'),
});

export type ShareChatThreadContentResponse = zod.input<typeof ShareChatThreadContentResponse>;
export type ShareChatThreadContentResponseOutput = zod.output<
  typeof ShareChatThreadContentResponse
>;
